/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
import '@itwin/itwinui-css/css/table.css';
import { useTheme } from '../../../utils';
import { Input } from '../../../Input';
import { FilterButtonBar, } from '../FilterButtonBar';
import { BaseFilter } from '../BaseFilter';
export const TextFilter = (props) => {
    var _a;
    const { column, translatedLabels, setFilter, clearFilter } = props;
    useTheme();
    const [text, setText] = React.useState((_a = column.filterValue) !== null && _a !== void 0 ? _a : '');
    const onKeyDown = (event) => {
        if (event.key === 'Enter') {
            setFilter(text);
        }
    };
    return (React.createElement(BaseFilter, null,
        React.createElement(Input, { value: text, onChange: (e) => setText(e.target.value), onKeyDown: onKeyDown, setFocus: true }),
        React.createElement(FilterButtonBar, { setFilter: () => setFilter(text), clearFilter: clearFilter, translatedLabels: translatedLabels })));
};
